import { setListenersFromSelector } from '../functions/listeners';
import alert from '../modules/alert';
import { querySelector, querySelectorId } from '../functions/querySelectors';
import dropFile from '../functions/dropFile';
import textlimit from '../functions/textlimit';
import formSubmit from '../modules/formSubmit';

const ADD_PHOTO = 'js-add-photo';
const ADD_INIT_PHOTO = 'jap-init';
const FILE_INPUT_CLASS = 'js-add-file';
const TEXTLIMIT_TEXTAREA_CLASS = 'js-photo-text-limit';
const TEXTLIMIT_SPAN_CLASS = 'js-photo-text-free';
const FORM_ID = 'gallery-add-photo-form';
const GALLERY_INNER_CLASS = 'c-gallery-add__inner';
const THANKS_CLASS = 'c-gallery-add--thanks';

let formError = function(event) {
  /* @TODO: onerror? */
};

let formSuccess = function(event) {
  let inner = querySelector(`.${GALLERY_INNER_CLASS}`);
  let parent = inner.parentNode;
  let div = document.createElement('div');

  div.innerHTML = event.detail.response;
  parent.removeChild(inner);
  parent.appendChild(div);
  parent.classList.add(THANKS_CLASS);
};

let initForm = function() {
  let form = querySelectorId(FORM_ID);
  formSubmit(form);
  form.addEventListener('formSuccess', formSuccess);
  form.addEventListener('formError', formError);
};

let afterOpen = function() {
  dropFile(querySelector(`.${FILE_INPUT_CLASS}`));
  textlimit(TEXTLIMIT_TEXTAREA_CLASS, TEXTLIMIT_SPAN_CLASS);
  initForm();
};

let addClick = function(event) {
  event.preventDefault();

  alert.open({
    url: this.getAttribute('href'),
    modifs: ['add-photo'],
    openCb: afterOpen
  });
};

export default function() {
  setListenersFromSelector(
    `.${ADD_PHOTO}`,
    ADD_INIT_PHOTO,
    addClick
  );
}
